import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpResponse } from '@angular/common/http';

// ** rxjs
import { Observable, of } from 'rxjs';
import { tap, catchError, map } from 'rxjs/operators';

// ** env
import { config } from '@app/core/app.config';

// ** service
import { ErrorCatchService } from './errorCatch.service';

@Injectable({
	providedIn: 'root',
})
export class ProductsService {
	constructor(
		private http: HttpClient,
		private router: Router,
		private httpClient: HttpClient,
		private errorCatchService: ErrorCatchService
	) {}

	// - 取得最新消息 (總覽)
	getProductsSheet(): Observable<any> {
		const fileName = 'products-sheet.json';
		return this.httpClient.get(`${config.products}/${fileName}`).pipe(
			map((res) => res),
			catchError(this.errorCatchService.handler)
		);
	}

	// - 取得產品細節
	getFullPiece(file: string) {
		const fileName = file;
		return this.httpClient.get(`${config.products}/${fileName}`).pipe(
			map((res) => res),
			catchError(this.errorCatchService.handler)
		);
	}
}
